// import components
import { styled } from '@mui/material';
import Grid, { GridProps } from '@mui/material/Grid';

export const StyledExtraHoursGrid = styled(Grid)<GridProps>(({ theme }) => ({
  compact: theme.spacing(2),
  medium: theme.spacing(4),
  expanded: theme.spacing(4)
}));
